<ng-container *transloco="let t;">
@for (activity of (activities$ | async); track activity.id) {
    @if (activity?.activity_type == 'log') {
        <div class="chat">
            <div class="chatContainer chatContainerStatic">
                <h5 class="topHead">
                    <ng-container *ngIf="activity?.signable_type === signableType.USER; else nonTenantOwner">
                        <app-sender-activity [activity]="activity" [roleDetail]="roleDetail"></app-sender-activity>
                    </ng-container>
                    <ng-template #nonTenantOwner>
                        <ng-container *ngIf="(activity?.log_status === signingStatusEnum.COMPLETED); else nonCompletedEevent">
                            <p>{{t("Activity log for signed by all (Activity log tab) - Document is signed by all participants")}}</p>
                        </ng-container>
                        <ng-template #nonCompletedEevent>
                            @if (activity?.log_status == signingStatusEnum.INVITED) {
                                {{ t("Activity log invite message (Activity log tab) - recipient has invited party to sign the document", {
                                    recipient : activity?.signable?.person | getRecipient,
                                    party: activity?.invited_recipient_role.person | getRecipient
                                }) }}
                            }@else if(activity?.log_status == "invited_to_read"){
                                {{ t("Activity log invite message (Activity log tab) - recipient has invited party to read the document", {
                                    recipient : activity?.signable?.person | getRecipient,
                                    party: activity?.invited_recipient_role.person | getRecipient
                                }) }}
                            }@else if(activity?.log_status == signingStatusEnum.REJECTED){
                                {{ t("Activity log reject message (Activity log tab) - recipient rejected document" , {
                                    recipient : activity?.signable?.person | getRecipient,
                                    document : roleDetail?.roleable?.visible_name ?? roleDetail?.roleable?.name,
                                    message : activity?.message
                                }) }}
                            }@else if(activity?.log_status == signingStatusEnum.FORWARDED){
                                {{ t("Activity log forwarded message (Activity log tab) - recipient has forwarded the document to party", {
                                    recipient : activity?.signable?.person | getRecipient,
                                    document : roleDetail?.roleable?.visible_name ?? roleDetail?.roleable?.name,
                                    party: activity?.invited_recipient_role.person | getRecipient
                                }) }}
                            }@else if(activity?.log_status === activityLogStatusEnum.RequestExtendDueDate){
                                    {{ t("Activity log extend due date message (Activity log tab) - recipient has requested to extend the due date", {
                                        recipient: (activity?.signable?.person | getRecipient)
                                    }) }}
                            }@else{
                                @if(activity?.log_status === signingStatusEnum.SIGNED && activity?.signable?.recipient_role_detail?.third_party_auth_response){
                                    @if(roleDetail?.authentication_type === authenticationTypeEnum.NORWEGIANBANKID){ 
                                        {{activity?.signable?.recipient_role_detail?.third_party_auth_response?.result?.identity?.fullName | titlecase}} 
                                    }@else if(roleDetail?.authentication_type === authenticationTypeEnum.FINNISHBANKID){
                                        {{activity?.signable?.recipient_role_detail?.third_party_auth_response?.identity?.FullName | titlecase}} {{t('Signed using text - registered events - signed using')}} FINNISH BANKID
                                    }@else{ 
                                        {{activity?.signable?.recipient_role_detail?.third_party_auth_response?.completionData?.user?.name | titlecase}} 
                                    }
                                }@else if(activity?.log_status === activityLogStatusEnum.Uploaded){
                                    @if(activity?.signable?.person){
                                        {{t("Activity log uploaded file (Activity log tab) - recipient uploaded file", {recipient: (activity?.signable?.person | getRecipient), file: activity?.attachment})}}
                                    }@else{ 
                                        {{t("Activity log uploaded file (Activity log tab) - recipient uploaded file", {recipient: (activity?.signable?.name), file: activity?.attachment})}}
                                    }
                                }@else{ 
                                    {{ activity?.signable?.person | getRecipient }} {{ activity | activityLog : roleDetail?.roleable?.visible_name ?? roleDetail?.roleable?.name }}
                                }
                            }
                        </ng-template>
                    </ng-template>
                </h5>
                <h2 class="no-span">
                      {{activity?.created_at | dateFormat | async}}
                </h2>
            </div>
        </div>
    } @else {
        <app-activity-log-messages [is_sender]="is_sender" [roleId]="roleId" [activity]="activity"></app-activity-log-messages>
    }
}
</ng-container>
